import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";

import TemplateList from "./TemplateList";

const Index = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs noTranslate pageName={t({ defaultMessage: "排程管理" })} />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">
          {t({ defaultMessage: "排程管理" })}
        </Typography>
      </div>
      <div className={classes.paperWrapper}>
        <TemplateList />
      </div>
    </>
  );
};

export default Index;
